import PropTypes from "prop-types";

const defs = {
	app: PropTypes.object,
	_LayoutPage: PropTypes.object,
	_LayoutHeader: PropTypes.object,
	_LayoutSidebar: PropTypes.object,
	_NavigationMenu: PropTypes.object,
	_LayoutBody: PropTypes.object,
	_LayoutFixedBody: PropTypes.object,
	_Prompter: PropTypes.object,
	ReactOModal: PropTypes.object,
	ReactOCollapse: PropTypes.object,
	ReactOForm: PropTypes.object,
	ReactOForm2: PropTypes.object,
	ReactOTabs: PropTypes.object,
	ReactOCarousel: PropTypes.object
}

export default defs